import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PlayStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M5.25 5.78993C5.25 4.421 6.75107 3.58155 7.91699 4.29872L18.0088 10.5097C19.1192 11.193 19.1192 12.8068 18.0088 13.4901L7.91699 19.7011C6.75119 20.4182 5.25032 19.5796 5.25 18.2108V5.78993ZM6.75 18.2108C6.75032 18.4061 6.96444 18.5258 7.13086 18.4237L17.2227 12.2128C17.3813 12.1151 17.3813 11.8846 17.2227 11.787L7.13086 5.57704C6.96429 5.47453 6.75 5.59435 6.75 5.78993V18.2108Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PlayStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PlayStrokeIcon;
